import { cn } from '~/shadcn/lib/utils'

function FiltersContainer({
  children,
  className,
  colorScheme = 'dark',
}: {
  children: React.ReactNode
  className?: string
  colorScheme?: 'dark' | 'light'
}) {
  const isDark = colorScheme === 'dark'

  return (
    <div
      className={cn(
        `${isDark ? 'bg-foreground border-border-strong' : 'bg-background border-border'} py-4 border-b`,
        className
      )}>
      {children}
    </div>
  )
}

export { FiltersContainer }
